import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const ConfirmBtn = styled(Button)({
  height: "48px",
  lineHeight: "48px",
  maxHeight: "48px",
  color: "#000000",
  fontSize: 14,
  width: "100%",
  fontFamily: "Gill Sans",
  textTransform: "uppercase",
  background: "#22D758",
  border: "none",
  borderRadius: "8px",
  "&:hover": {
    background: "#37FF73",
    color: "#000000",
  },
  "&:disabled": {
    background: "#013310",
  },
});
